import React from 'react';
import { RICH_TEXT_OPTIONS } from 'consts/contentful';

import { HowItWorks } from './HowItWorks';
import type { HowItWorksEntry } from 'schema';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { SmartImage } from 'components/global/SmartImage';

export const ContentfulHowItWorks = ({
  body,
  media,
  header,
  ...props
}: HowItWorksEntry) => (
  <HowItWorks
    {...props}
    title={header}
    subtitle={body && documentToReactComponents(body, RICH_TEXT_OPTIONS)}
    media={<SmartImage {...media} layout="fullWidth" loading="lazy" />}
  />
);
